import { useUserStore } from "~/store/UserStore";

export default defineNuxtPlugin(() => {
  const userStore = useUserStore();

  // Ensure in-memory auth state matches cookies and hydrate cached CLD user ASAP.
  userStore.setIsAuthenticated();

  // Keep store in sync across client-side navigations/redirects.
  const nuxtApp = useNuxtApp();
  nuxtApp.hook("page:start", () => {
    userStore.setIsAuthenticated();
  });
});
